/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Highlight_Purpose_TitleInputs */



/**
* | output |
* | --- |
* | "Purpose-built for teams" |
*
* @param {Pricing_Highlight_Purpose_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_highlight_purpose_title = /** @type {((inputs?: Pricing_Highlight_Purpose_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Highlight_Purpose_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Für Teams entwickelt")
	return /** @type {LocalizedString} */ ("Purpose-built for teams")
});